import { ReactNode } from 'react'

import { SkatConnectionContextProvider } from '@features/vatDeclarations/contexts/skatConnectionContext'

import { useVatDeclaration } from '../../../../context/vatDeclarationContext'

interface VatDeclarationSkatWrapperProps {
  children: ReactNode
}

export const VatDeclarationSkatWrapper = ({ children }: VatDeclarationSkatWrapperProps) => {
  const { skatTransactionId } = useVatDeclaration()

  return <SkatConnectionContextProvider skatTransactionId={skatTransactionId}>{children}</SkatConnectionContextProvider>
}
